import { GEO_API } from '../apiGeo/constants';

import { useSearchApiGouv } from './useSearchApiGouv';

export interface FetchDepartementSearchResult {
  nom: string;
  code: string;
}

export interface DepartementApiGouvOption {
  nom: string;
  code: string;
}

function buildSearchDepartementUrl(option: DepartementApiGouvOption): string {
  return `${GEO_API}/departements?limit=15&nom=${encodeURI(option.nom)}`;
}

function mapFetchResultToOptions(
  result: Array<FetchDepartementSearchResult>,
): Array<DepartementApiGouvOption> {
  return result.map(option => {
    return {
      code: option.code,
      nom: option.nom,
    };
  });
}

export const useSearchDepartementApiGouv = (): [
  Array<DepartementApiGouvOption>,
  boolean,
  (str: string) => void,
] => {
  const [options, isFetching, fetchOptions] = useSearchApiGouv(
    {
      nom: '',
      code: '',
    },
    (option: DepartementApiGouvOption) => option.nom,
    buildSearchDepartementUrl,
    search => {
      return { nom: search, code: '' };
    },
    mapFetchResultToOptions,
  );

  return [options, isFetching, fetchOptions];
};
